export const adaptCMSSearchStaticLinks = (data) => {
  if (!Array.isArray(data)) {
    console.error("Expected an array but received", data);
    return [];
  }

  return data.map(({ header, callToAction }) => ({
    header,
    links: callToAction.map(({ link, linkText }) => ({
      url: link,
      label: linkText,
    })),
  }));
};
